// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
import type { Date, DateFormatFunctions } from './type';
import { dateTypeChecker } from './type-checker';

export function getDateType(date: Date) {
  return Object.keys(dateTypeChecker).find((key) => dateTypeChecker[key as keyof typeof dateTypeChecker](date)) as
    | keyof typeof dateTypeChecker
    | undefined;
}

export function parseDate(date: Date, formatFunction: DateFormatFunctions): string {
  const type = getDateType(date);
  return formatFunction[type as keyof typeof formatFunction]?.(date);
}
